import { Blog } from "../../core/models/Blog";
import { FirebaseBlogRepository } from "../../core/repositories/blog/implementations/FirebaseBlogRepository";
import IBlogRepository from "../../core/repositories/blog/interfaces/IBlogRepository";
import Cubit from "../../core/utils/cubit";
import { IProcessingService, ProcessingService } from "../processing-service/ProcessingService";
import { BlogsState } from "./blogStates";

abstract class IBlogsCubit extends Cubit<BlogsState> {
    abstract getAllBlogs: () => Promise<BlogsState>;
}

class BlogsCubit extends IBlogsCubit {

    private blogsRepository: IBlogRepository = new FirebaseBlogRepository();
    protected processingService: IProcessingService = ProcessingService.getInstance();

    constructor(private categories: string[] = []) {
        super({ state: 'LOADING' });
    }

    getAllBlogs: () => Promise<BlogsState> = async () => {
        this.emit({ state: 'LOADING' });
        this.processingService.startProcessing();
        var blogs: Blog[] | undefined;
        var categories: string[] = [];
        try {
            blogs = await this.blogsRepository.getBlogs(this.categories);
            categories = await this.blogsRepository.getCategories();
            this.emit({ state: 'LOADED', blogs, categories });
        } catch (error) {
            this.emit({ state: 'ERROR' });
        }
        this.processingService.stopProcessing();
        return this.state;

    }

}

export { BlogsCubit, IBlogsCubit };
